<template>
  <hm-container bgTransparent noPadding>
    <div class="header" slot="header">
      <div class="selected-activity caption bold">
        用户特征画像
      </div>
      <div class="flex item-center">
        <div class="flex info-item item-center">
          <!-- <img class="user-image" :src="details.userImage" alt="商品图" /> -->
          <div class="bold user-name">
            {{ details.memberName }}
          </div>
        </div>
        <!-- <div class=" info-item">userId:{{ details.centerId }}</div> -->
        <!-- <div class=" info-item">cookiid:{{ details.userId }}</div> -->
      </div>
      <div class="user-info flex flex-between">
        <div>
          <div class="flex flex-wrap">
            <div class="info-item" v-if="details.memberSex">
              用户性别:{{ details.memberSex | genderFormat }}
            </div>
            <div class="info-item" v-if="details.age">
              年龄:{{ details.age }}
            </div>
          </div>
          <div class="flex flex-wrap">
            <!-- <div class="info-item">购物性别:{{ details.shopPrice }}</div> -->
            <div class="info-item" v-if="details.phoneNum">
              电话号码:{{ details.phoneNum }}
            </div>
          </div>
        </div>
        <div>
          <div class="flex flex-wrap">
            <div class="info-item" v-if="details.createDate">
              注册时间:{{ details.createDate }}
            </div>
            <div class="info-item" v-if="details.liveProvince">
              常驻省份:{{ details.liveProvince }}
            </div>
          </div>
          <div class="flex flex-wrap" v-if="details.liveCity">
            <div class="info-item">常驻城市:{{ details.liveCity }}</div>
          </div>
        </div>
        <div>
          <div class="flex flex-wrap">
            <div class="info-item" v-if="details.isParents">
              是否有宝宝:{{ details.isParents }}
            </div>
            <div class="info-item" v-if="details.babies">
              宝宝数量:{{ details.babies }}
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="info-item" v-if="details.isPregnant">
              是否怀孕：{{ details.isPregnant ? "是" : "否" }}
            </div>
            <div class="info-item" v-if="details.edc">
              预产期：{{ details.edc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex main">
      <!-- <div class="flex flex-between">
        <div class="portrait-card flex-1">
          <div class="selected-activity caption bold">
            30秒认识客户
          </div>
          <div>
            <div
              id="catCharacteristics"
              style="width: 180px;height:200px;"
            ></div>
          </div>
        </div>
        <div class="portrait-card flex-1">
          <div class="selected-activity caption bold">
            消费能力
          </div>
          <ul class="consumption-list flex flex-between">
            <li class="list-item flex-1">
              <span>手机品牌</span>
              <div class="title bold">{{ details.mobileName }}</div>
            </li>
            <li class="list-item center flex-1">
              <span>最近30天客单价</span>
              <div class="title bold">{{ details.mobileName }}元</div>
            </li>
            <li class="list-item flex-1">
              <span>最近30天购物次数</span>
              <div class="title bold">{{ details.mobileName }}</div>
            </li>
          </ul>
          <div class="total-consumption flex item-center">
            总消费金额：<span class="bold price"
              >{{ details.totalPrice }}元</span
            >
          </div>
        </div>
        <div class="portrait-card flex-1">
          <div class="selected-activity caption bold">
            二级品类偏好
          </div>
          <div id="catPreference" style="width: 480px;height:200px;"></div>
        </div>
      </div> -->
      <!-- <div class=""> -->
      <div class="portrait-tree-wrapper">
        <div class="flex flex-between">
          <div class="selected-activity caption bold">
            全部标签
          </div>
          <div class="flex">
            <el-radio-group v-model="isTake" @change="getChange">
              <el-radio :label="1">生效中</el-radio>
              <el-radio :label="2">已失效</el-radio>
            </el-radio-group>
          </div>
        </div>

        <el-tree
          default-expand-all
          :data="treeData"
          :props="defaultProps"
          node-key="id"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ data }">
            <span>{{ data.catName }}</span>
            <span
              v-if="!data.hasOwnProperty('children')"
              style="margin-right:10px"
            >
              <el-button
                type="text"
                size="small"
                @click="() => deleteData(data)"
              >
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div class="flex-1 table-wrapper">
        <div class="selected-activity caption bold">
          用户标签日志
        </div>
        <el-table stripe :data="details.logs">
          <el-table-column
            label="序号"
            header-align="center"
            align="center"
            type="index"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="content"
            show-overflow-tooltip
            label="日志内容"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            show-overflow-tooltip
            label="日志时间"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- </div> -->
    </div>
  </hm-container>
</template>

<script>
export default {
  components: {},
  props: {
    centerId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      chartSettings: {
        shape: "circle"
      },
      chartData: {
        columns: ["word", "count"],
        rows: []
      },
      isTake: 1,
      details: {
        createDate: "",
        shopPrice: "",
        category: "",
        userId: "",
        userImage:
          "https://imgcdn.hemiao100.com/tag/SketchPng9c4340c9bed86cc0ccec5eca942de6e0d27984ce1cb93e050a0110a38075d84b.png",
        memberName: "",
        memberSex: "",
        logs: [],
        age: "",
        liveProvince: "",
        liveCity: "",
        isParents: "",
        edc: ""
      },
      treeData: [],
      defaultProps: {
        children: "children",
        label: "catName"
      }
    };
  },
  filters: {
    genderFormat(val) {
      return val === "unknow" ? "未知" : val;
    }
  },
  created() {
    this.get_init();
  },
  mounted() {},
  methods: {
    async get_init() {
      const { result } = await this.$store.dispatch(
        "queryPortraitDetailsByUser",
        {
          invalid: this.isTake === 1,
          relId: this.centerId
        }
      );
      if (result.cats) {
        result.cats.forEach(v => {
          if (v.children) {
            v.children.forEach(o => {
              o.catName = o.tagName + "：" + o.calcValue;
            });
          }
        });
        console.log("result.cats: ", result.cats);
      }
      this.treeData = [
        {
          catName: "用户画像",
          children: result.cats
        }
      ];
      this.details = result;
    },

    async deleteData(data) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("queryTagDelete", {
          tagName: data.tagName,
          source: "userPortrait",
          ids: this.details.centerId,
          state: "0"
        });
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.get_init();
      }
    },
    getChange() {
      this.get_init();
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  font-size: 14px;
  .user-name {
    font-size: 16px;
  }
  .user-image {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-right: 8px;
  }
  .user-info {
    margin-top: 20px;
  }
  .info-item {
    margin-right: 102px;
    margin-bottom: 14px;
  }
}
.main {
  height: calc(100vh - 318px);
  .portrait-tree-wrapper {
    background: #fff;
    padding: 30px;
    margin-right: 10px;
    width: 490px;
    // height: 100%;
    overflow-y: auto;
    .custom-tree-node {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

  .table-wrapper {
    padding: 30px;
    background: #fff;
    // height: 100%;
    overflow-y: auto;
  }

  .portrait-card {
    padding: 30px;
    background: #fff;
    margin-bottom: 10px;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }

  .consumption-list {
    font-size: 14px;
    text-align: center;
    .title {
      font-size: 16px;
      margin-top: 20px;
    }
    .list-item {
      &.center {
        border-left: 1px solid rgba($color: #ddd, $alpha: 0.5);
        border-right: 1px solid rgba($color: #ddd, $alpha: 0.5);
      }
    }
  }

  .total-consumption {
    width: 100%;
    height: 44px;
    line-height: 44px;
    background: linear-gradient(270deg, #ffffff 0%, #f5f5f5 100%);
    border-radius: 22px;
    font-size: 14px;
    padding: 11px 18px;
    box-sizing: border-box;
    margin-top: 30px;
    .price {
      font-size: 16px;
    }
  }
}
</style>
